import * as angular from 'angular';
import { map, Observable, Subject, takeUntil } from 'rxjs';

import { DatasetFacade } from '@mode/dataset/contract';
import { DataViewTypes, ExportedDatasetSourceContent, FeatureFlag } from '@mode/shared/contract-common';
import { DataViewFacade } from '@mode/switch-views/contract';
import { getInitialFlagValue } from '@mode/shared/util-js';

class ReportDetailsQueryController {
  static $inject = ['$stateParams', 'DataViewFacade', 'DatasetFacade'];

  queryId: string;
  runIdUrlParam: string;
  showParameterCode = false;
  isSheetsDataset = false;
  sheetMetadata: DataViewTypes.GoogleSheetMetadata | null = null;
  private destroy$ = new Subject<void>();

  exportedDatasetSource$: Observable<ExportedDatasetSourceContent>;
  isNotebookCellDataset$: Observable<boolean>;

  enableNotebookExportDatasets = getInitialFlagValue(FeatureFlag.NotebookExportDatasets);

  queryToken: string;
  isNotebookCell: boolean | undefined = false;

  constructor(
    private $stateParams,
    private dataViewFacade: DataViewFacade,
    private datasetFacade: DatasetFacade
  ) {}

  $onInit() {
    this.runIdUrlParam = this.$stateParams['runId'];
    this.queryId = this.$stateParams['queryId'];

    this.exportedDatasetSource$ = this.datasetFacade.exportedDatasetSource$;

    const dataset$ = this.dataViewFacade.getDatasetResultByQuery(this.queryId);

    this.isNotebookCellDataset$ = dataset$.pipe(
      map((dataset) => this.datasetFacade.isNotebookCellDataset(dataset?.producerType))
    );

    dataset$.pipe(takeUntil(this.destroy$)).subscribe({
      next: ({ producerType, queryToken }) => {
        this.isSheetsDataset = this.datasetFacade.isSheetDataset(producerType);
        this.queryToken = queryToken;
      },
    });

    dataset$.pipe(takeUntil(this.destroy$)).subscribe({
      next: (dataset) => (this.sheetMetadata = this.datasetFacade.getSheetMetadata(dataset)),
    });

    if (this.enableNotebookExportDatasets) {
      this.isNotebookCellDataset$.pipe(takeUntil(this.destroy$)).subscribe((isNotebookCellDataset) => {
        this.isNotebookCell = isNotebookCellDataset;
        if (isNotebookCellDataset) {
          this.datasetFacade.loadExportedDatasetSource(this.queryToken);
        }
      });
    }
  }

  $onDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}

export const ID = 'reportDetailsQuery';

export const reportDetailsQuery: angular.IComponentOptions = {
  template: `
    <div class="report-details">
      <mode-metadata-summary ng-if="ctrl.sheetMetadata && ctrl.isSheetsDataset"
        [spreadsheet-name]="ctrl.sheetMetadata.spreadsheetName"
        [worksheet-name]="ctrl.sheetMetadata.worksheetName"
        [spreadsheet-url]="ctrl.sheetMetadata.spreadsheetUrl"
        [worksheet-range]="ctrl.sheetMetadata.worksheetRange"
        [owned-by]="ctrl.sheetMetadata.ownedBy"
        [connected-by]="ctrl.sheetMetadata.connectedBy"
        [last-synced]="ctrl.sheetMetadata.lastSynced"
        [last-synced-by]="ctrl.sheetMetadata.lastSyncedBy"
      ></mode-metadata-summary>

      <div ng-if="!ctrl.isSheetsDataset" style="height: 100%;">
        <div class="report-query-header" ng-if="!ctrl.isNotebookCell">
          <div class="show-parameter-checkbox">
            <span class="checkbox-icon">
              <input type="checkbox" ng-model="ctrl.showParameterCode" name="show-parameter-code" id="showParameterCode">
              <label class="inline-icon icon-editor-checkbox-light-unchecked" for="showParameterCode">Show parameter code</label>
            </span>
          </div>
        </div>

        <mode-export-dataset-view
          [exported-dataset-source]="ctrl.exportedDatasetSource$ | async"
          ng-if="ctrl.isNotebookCell && (ctrl.exportedDatasetSource$ | async)">
        </mode-export-dataset-view>

        <mode-query [query-id]="ctrl.queryId" [is-raw-query]="ctrl.showParameterCode" ng-if="!ctrl.isNotebookCell"></mode-query>
       </div>
       <mode-query class="report-query-content code-container" [query-id]="ctrl.queryId" [is-raw-query]="ctrl.showParameterCode"></mode-query>
    </div>
  `,
  controller: ReportDetailsQueryController,
  controllerAs: 'ctrl',
};
